import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/care-plan/$patientId/')({
  beforeLoad: ({ params }) => {
    throw redirect({ to: '/care-plan/$patientId/plan', params: { patientId: params.patientId } });
  },
});
